import React from 'react';
import CardSimple from 'screens/components/basic/CardSimple';

const ClockInClockOut = () => {
    return(
        <div id="clock-in-out-how-to">
            <br />
            <div>
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to clock in/clock out</h2>
                        <h1>Without logging into the system</h1>
                        <ul>
                            <li>Click on Clock In/ Clock Out</li>
                            <img src="http://techpos.ca/support-images/ClockIn-Out/ClockIn-1.png" />
                            <li>Type your employee number and click on confirm to take the picture and clock in/ clock out</li>                           
                            <img src="http://techpos.ca/support-images/ClockIn-Out/Clockin-2.png" />
                        </ul>
                        <h1>With logging into the system</h1>
                        <ul>
                            <li>Click on the menu beside your name</li>
                            <img src="http://techpos.ca/support-images/ClockIn-Out/Clockin-3.png" />
                            <li>Click on Clock In/ Clock Out</li>                           
                            <li>Enter your employee number and click on confirm to take the picture and clock in/ clock out</li>
                            <li><strong>NOTE:</strong> If this is the first time you clock in/clock out, please make sure to grant the application
                            permission to access your camera in the pop-up message.</li>                           
                            <img src="http://techpos.ca/support-images/ClockIn-Out/Clockin-5.png" />
                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="clock-in-out-problem">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>If there's a problem with your shift</h2>
                        <h3>If you get the following error:</h3>
                        <img src="http://techpos.ca/support-images/ClockIn-Out/Clockin-4.png" />
                        <h3>Please make sure that:</h3>
                        <ul>
                            <li>There is a webcam connected to the computer</li>                           
                            <li>The cables of the webcam are well connected</li>                           
                            <li>TechPOS has permission to take access the camera (for instructions, see the section How to give
                            permission to access the camera on this document)</li>                           
                        </ul>
                    </div>
                </CardSimple>
            </div>
        </div>
    )
}

export default ClockInClockOut;